const resources = { showMore: 'Show more' };

export default function getResource(label) {
    return resources[label];
}
